<template>
<div id="dataset-elem">
  <div class="content-header text-center">
    <div class="float-end text-right">
      <button type="button" @click="sortData"><i class="fa" :class="sorticon"></i></button>
    </div>
    <h2>Datasets</h2>
  </div>
  <div class="container-fluid min-content-height">

    <div class="row">
        <div class="col-sm">
            <a v-if="this.userStatus == 'active' && (this.userSubscription.subscription != 'single' || parseInt(this.userSubscription.remaining_dataset) >= 1)" 
              class="btn col-md-6 offset-md-3 btn-lg btn-info" @click="$emit('openModal', {view: 'DatsetUploadDialog', dt: ''})"><span class="sidebar-text">Upload a Dataset <i class="fas fa-angle-right"></i></span></a>
            <a v-else-if="this.userStatus != 'active'" class="btn col-md-6 offset-md-3 btn-lg btn-info" @click="$emit('customChange', {shell: 'SelectSubscription', dataset: ''})"><em>Purchase/renew user license</em></a>
            <p v-else class="col-md-6 offset-md-3 text-center"><em>You have uploaded the maximum number of datasets included in your license</em><br><br>
              <button class="btn btn-lg btn-info" @click="$emit('customChange', {shell: 'SelectSubscription', dataset: ''})"><em>Purchase/renew user license</em></button>
            </p>
            <hr>
        </div>
    </div>

    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <div class="btn-group-vertical col-12" v-for='(data, index) in datasets'>
          <div class="btn-group mb-2" role="group" aria-label="DatasetExists" v-if="this.checkDatasetLoad(data)">
            <a class="btn col-6 btn-lg btn-primary" @click="$emit('customChange', {shell: 'DataShell', dataset: String(data)})"><span class="sidebar-text">{{data}}</span></a>
            <a v-if="this.isAdmin" class="btn col-2 btn-lg btn-warning" @click="$emit('openModal', {view: 'TransferDatasetForm', dt: String(data)})"><i class="fas fa-random"></i></a>
            <a class="btn col-2 btn-lg btn-danger" @click="customDeleteDataset(String(data))"><i class="fas fa-trash-alt"></i></a>
            <a class="btn col-2 btn-lg btn-info" @click="$emit('openModal', {view: 'RenameDatasetForm', dt: String(data)})"><i class="fas fa-edit"></i></a>
            <!-- a v-if="this.userData.organization == 'my_organization'" class="btn col-2 btn-lg btn-warning" @click="$emit('openModal', {view: 'TransferDatasetForm', dt: String(data)})"><i class="fas fa-random"></i></a -->
          </div>
          <div class="btn-group mb-2" role="group" aria-label="DatasetProcessing" v-else>
            <a class="btn col-12 btn-lg btn-primary" disabled="disabled"><em>{{data}}<i class="fas fa-spinner fa-pulse"></i></em></a>
            <a v-if="this.isAdmin" class="btn col-2 btn-lg btn-warning" @click="$emit('openModal', {view: 'TransferDatasetForm', dt: String(data)})"><i class="fas fa-random"></i></a>
            <a class="btn col-2 btn-lg btn-warning" v-if="(String(reports[index]) === undefined ||  String(reports[index]) == null || String(reports[index]).length <= 0) != '' && String(reports[index]) != String(data)" @click="$emit('openModal', {view: 'ModalDeleteDataset', dt: String(reports[index])})"><i class="fas fa-trash-alt"></i></a>
            <a class="btn col-2 btn-lg btn-danger" v-else @click="$emit('openModal', {view: 'ModalDeleteDataset', dt: String(data)})"><i class="fas fa-trash-alt"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import axios from 'axios';
var DomParser = require('dom-parser');
var parser = new DomParser();
var host = window.location.origin;
export default {
  name: 'app',
  data () {
    return {
      userData: [],
      datasets: [],
      reports: [],
      component: '',
      selectedValue: '',
      sorticon: 'fa-sort-alpha-down'
    }
  },
  props: {
    isAdmin: false,
    userData: [],
    userSubscription: [],
    userStatus: ''
  },
  mounted () {
    axios({
      method : 'POST',
      url : '/list_datasets',
      data:'',
    }).then(
      (response) => {
        this.datasets = processDatasets(response.data);
        console.log('process datasets list '+response.data);
      })
      .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
    });
    axios({
      method : 'POST',
      url : '/list_reports',
      data:'',
    }).then(response => this.reports = processDatasets(response.data))
      .catch(error => {
        this.errorMessage = error.message;
        console.error("There was an error!", error);
    });
  },
  methods : {
    returnUpdatedList() {
      axios({
        method : 'POST',
        url : '/list_datasets',
        data:'',
      }).then(
        (response) => {
          this.datasets = processDatasets(response.data)
        }
      )
        .catch(error => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
      });
    },
    customDeleteDataset(filename) {
      axios.get('/remove_dataset', { params: {dataset: filename} })
      .then(
			(response) => {
        this.$emit('messageAlert', {alert: 'Deleting selected Dataset.', classel: 'info'});
        //this.returnUpdatedList();
        this.$emit("forceRerender");
      }).catch(error => {
        this.errorMessage = error.message;
        this.$emit('messageAlert', {alert: 'There was an error!', classel: 'error'});
        console.error("There was an error!", error);
    });
    },
    checkDatasetLoad(curDataset) {
      if(this.reports.indexOf(curDataset) !== -1) {
        return true;
      } else {
        return false;
      }
    },
    sortData() {
      if(this.sorticon == 'fa-sort-alpha-down') {
        this.sorticon = 'fa-sort-alpha-up';
        this.datasets.sort(function(a, b) {
          return b.localeCompare(a);
        });
      } else {
        this.sorticon = 'fa-sort-alpha-down';
        this.datasets.sort(function(a, b) {
          return a.localeCompare(b);
        });
      }
      // console.log('sorting function');
      // this.datasets.reverse();
    }
  }
}
function processDatasets(data) {
      var iH = [];
      var i;
      var b = data;
      for (i = 0; i < b.length; i++) {
        if (b[i].includes('scored-') || b[i].includes('prospect') || b[i].includes('baseline'))
          continue;
            iH.push(b[i]); 
      };
      return iH;
};
</script>